import React, { useCallback } from 'react';

import { Typography } from '@occc-app/design-system';

import ChipGroupItem, { IChipGroupItemProps } from './ChipGroupItem';

type Option = {
  label: string;
  value: string;
};

export interface IChipGroupProps {
  options: Option[];
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  disabled?: boolean;
}

const ChipGroup = ({ options, value, onChange, label, disabled }: IChipGroupProps) => {
  const onClick = useCallback<IChipGroupItemProps['onClick']>(
    (fieldValue) => {
      if (!value.includes(fieldValue)) {
        const valueWithNewItem = value.concat(fieldValue);
        onChange(valueWithNewItem);
      } else {
        const valueWithRemovedItem = value.filter((item) => item !== fieldValue);
        onChange(valueWithRemovedItem);
      }
    },
    [value, onChange],
  );

  return (
    <>
      {label && <Typography paragraph>{label}</Typography>}
      {options.map((item) => (
        <ChipGroupItem
          disabled={disabled}
          key={item.value}
          value={item.value}
          onClick={onClick}
          label={item.label}
          selected={value.includes(item.value)}
        />
      ))}
    </>
  );
};

export default ChipGroup;
